import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-6 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto bg-white shadow-xl rounded-lg overflow-hidden border border-gray-100">
        <div className="p-4 sm:p-12">
          {/* Main Title */}
          <h1 className="text-3xl sm:text-4xl font-extrabold text-gray-900 mb-4 border-b-2 border-gray-200 pb-4">
            Privacy Policy
          </h1>

          {/* Date Added Here */}
          <p className="text-sm text-gray-500 mb-8 italic font-medium">
            Update at 10/01/2026
          </p>
          
          <div className="text-gray-800 space-y-6 leading-relaxed text-base">
            
            {/* Intro */}
            <p>
              This Privacy Policy explains how <span className="font-bold">Regees Tex</span> collects, uses, and protects the personal information of users who access and use this Website. By using the Website, you consent to the collection and use of information in accordance with this Privacy Policy.
            </p>

            {/* Information We Collect */}
            <div>
              <h2 className="text-xl font-bold text-gray-900 mb-4">
                Information We Collect
              </h2>
              <ul className="list-disc pl-5 space-y-2">
                <li>Name</li>
                <li>Email address and phone number</li>
                <li>Demographic information</li>
                <li>Survey and feedback data</li>
                <li>Cookies and browsing information</li>
              </ul>
            </div>

            {/* Use of Information */}
            <div>
              <h2 className="text-xl font-bold text-gray-900 mb-2">
                Use of Information
              </h2>
              <p>
                Information is used for internal records, service improvement, promotional communication, customer support, market research, and website personalization.
              </p>
            </div>

            {/* Data Security */}
            <div>
              <h2 className="text-xl font-bold text-gray-900 mb-2">
                Data Security
              </h2>
              <p>
                Appropriate physical, electronic, and administrative safeguards are implemented to protect personal data stored in India.
              </p>
            </div>

            {/* Cookies */}
            <div>
              <h2 className="text-xl font-bold text-gray-900 mb-2">
                Cookies
              </h2>
              <p>
                Cookies are used to enhance user experience and improve website performance. Users may choose to disable cookies through their browser settings, which may affect certain functionalities.
              </p>
            </div>

            {/* Third-Party Links */}
            <div>
              <h2 className="text-xl font-bold text-gray-900 mb-2">
                Third-Party Links
              </h2>
              <p>
                The Website may contain links to third-party websites. <span className="font-bold">Regees Tex</span> is not responsible for the privacy practices or content of such external websites. Users are encouraged to review the privacy policies of those websites independently.
              </p>
            </div>

            {/* Control and Access */}
            <div>
              <h2 className="text-xl font-bold text-gray-900 mb-2">
                Control and Access
              </h2>
             <p className="mb-4">
              Customers may opt out of marketing communications and request access or correction of personal data by emailing{" "}
              <a
                href="mailto:rtexiles1985@gmail.com"
                className="font-bold text-black hover:underline"
              >
                rtexiles1985@gmail.com
              </a>.
            </p>

              <p>
                Personal information is <span className="font-bold">not sold, rented, or leased</span> to third parties, except where required by law or with the explicit consent of the customer.
              </p>
            </div>

            {/* Policy Updates */}
            <div>
              <h2 className="text-xl font-bold text-gray-900 mb-2">
                Policy Updates
              </h2>
              <p>
                Regees Textile reserves the right to modify or update this Privacy Policy at any time. Continued use of the Website constitutes acceptance of the revised policy.
              </p>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;